import { getIn } from 'formik';
import TextEditorRaw from '~/components/common/TextEditor';

interface Props {
  form: any;
  field: any;
  disabled?: boolean;
}

const TextEditor = ({ field, form, disabled = false, ...props }: Props) => (
  <TextEditorRaw
    {...field}
    name={field.name}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    onChange={(value) => form.setFieldValue(field.name, value)}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
);

export default TextEditor;
